import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Col, Form, Row } from 'react-bootstrap';
import NoteDropdown from '../noteDropdown';
import { useClickAway } from 'react-use';
import {
  itemSettingStyle,
  lineHeightStyle,
  getSides,
  checkDoctorDept,
  noteInline,
  isNoteUnderLine,
} from '../../../../utils/helpers';
import CommonDeleteBtn from '../commonDeleteBtn';
import SelectedItemSearch from './selectedItemSearch';
import ChiefComplainDeleteBtn from '../chiefComplainDeleteBtn';

const Observation = ({
  deletePrescriptionItem,
  selectedOnExamination,
  setSelectedOnExamination,
  prescriptionItems,
  isHistoryPage,
}) => {
  const [isEdit, setIsEdit] = useState('');
  const userInfo = useSelector((state) => state.authReducer.data);
  const specialties = useSelector((state) => state.specialtyReducer.specialties);
  const allNotes = useSelector((state) => state?.prescriptionReducer?.prescriptionInfo?.itemElementNotes || []);

  const ref = useRef(null);
  useClickAway(ref, (e) => {
    setIsEdit('');
  });

  const handleNoteOfObservation = (item, fieldName, val) => {
    const objIndex = selectedOnExamination?.observations.findIndex(
      (data) => data.name === item.name,
    );

    if (objIndex !== -1) {
      const updatedData = [...selectedOnExamination?.observations];
      updatedData[objIndex] = {
        ...updatedData[objIndex],
        [fieldName]: val,
      };

      setSelectedOnExamination({
        ...selectedOnExamination,
        observations: updatedData,
      });
    }
  };

  const editMode = (item) => {
    return (
      <Row ref={ref} className="selected-row-edit" key={`${item.name}`}>
        <Col className="pr-0 pl-0">
          <SelectedItemSearch
            apiUrl="observations"
            selectedItemName={item.name}
            selectedItems={selectedOnExamination}
            selectedItemsAction={setSelectedOnExamination}
            observation={true}
          />
        </Col>
        <Col md={2}>
          <Form.Select
            className="form-control form-control-sm"
            value={item.side || ''}
            onChange={(e) =>
              handleNoteOfObservation(item, 'side', e.target.value)
            }
          >
            <option value="">Side</option>
            {getSides(
              checkDoctorDept(
                'opthalmology',
                userInfo?.speciality[0],
                specialties,
              ),
            ).map((side) =>
              Object.entries(side).map(([value, label]) => (
                <option key={value} value={value}>
                  {label}
                </option>
              )),
            )}
          </Form.Select>
        </Col>
        <Col className="pl-0 pr-0">
          <NoteDropdown
            value={item.note || ''}
            onChange={(val) => handleNoteOfObservation(item, 'note', val)}
            placeholder="Add Note"
            suggestions={allNotes.filter(
              (n) => n.elementType === 'observation' && n.itemElement?.toLowerCase() === item.name?.toLowerCase(),
            )}
          />
        </Col>
        <Col md={1} style={{ textAlign: 'right' }}>
          <i
            className="far fa-times-circle"
            aria-hidden="true"
            onClick={() => setIsEdit('')}
          ></i>
        </Col>
      </Row>
    );
  };

  return (
    <ul style={lineHeightStyle('on-examination', prescriptionItems)}>
      {selectedOnExamination?.observations?.map((item, index) => (
        <li key={index} style={{ position: 'relative' }}>
          <div onClick={() => setIsEdit(index)}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span
                style={itemSettingStyle(
                  prescriptionItems?.items?.['on-examination']?.itemStyle || {},
                )}
              >
                {item.name ? ` ${item.name}` : ''}
                {item?.side ? ` - ${item?.side?.toUpperCase()}` : ''}
                {noteInline(item.note, 'on-examination', prescriptionItems)}
              </span>
              {!isHistoryPage && (
                <ChiefComplainDeleteBtn
                  action={deletePrescriptionItem}
                  itemName="onExamination"
                  delId={item.name}
                />
              )}
            </div>
            {item?.note && isNoteUnderLine('on-examination', prescriptionItems) && (
              <div
                className="pl-2 preline ovation-list"
                style={itemSettingStyle(
                  prescriptionItems?.items?.['on-examination']?.subItemStyle ||
                    {},
                )}
              >
                - {item?.note}
              </div>
            )}
          </div>
          {index === isEdit && editMode(item)}
        </li>
      ))}
    </ul>
  );
};

export default Observation;
